export const listActivityLogs = `
   query listActivityLogs($filter: ActivityLogsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listActivityLogs(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
                id
                username
                user {
                    username
                    email
                    name
                    status
                    created
                }
                usageType
                value
                action
                recordId
                recordType
                created
           }
           nextToken
       }
   }
`;

export const getActivityLog = `
   query getActivityLog($id:ID!) {
       getActivityLog(id:$id) {
                id
                username
                user {
                    username
                    email
                    name
                    status
                    created
                }
                usageType
                value
                action
                recordId
                recordType
                created
       }
}`;
